import React from 'react';
import clsx from 'clsx';
import { Search, X } from 'lucide-react';

export interface SearchPillProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size' | 'onChange'> {
    value: string;
    onChange: (value: string) => void;
    /** 50 · 48 · 38 (sunken, for sheets) */
    size?: 'lg' | 'md' | 'sm';
    onClear?: () => void;
    className?: string;
}

const sizes = {
    lg: 'h-[50px] px-[18px] text-[15px] gap-2.5 bg-surface-card border border-line [&>svg]:w-[18px] [&>svg]:h-[18px]',
    md: 'h-12 px-4 text-[15px] gap-2.5 bg-surface-card border border-line [&>svg]:w-[18px] [&>svg]:h-[18px]',
    sm: 'h-[38px] px-3.5 text-[13px] gap-2 bg-surface-sunken [&>svg]:w-[15px] [&>svg]:h-[15px]',
};

export const SearchPill = React.forwardRef<HTMLInputElement, SearchPillProps>(({ value, onChange, size = 'md', onClear, className, ...props }, ref) => (
    <label
        className={clsx(
            'flex min-w-0 flex-1 items-center rounded-pill text-ink-muted transition-[border-color,box-shadow] duration-200 focus-within:border-accent-500 focus-within:shadow-focus',
            sizes[size],
            className,
        )}
    >
        <Search className="shrink-0" />
        <input
            ref={ref}
            type="search"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className="min-w-0 flex-1 bg-transparent font-semibold text-ink-primary outline-none placeholder:font-normal placeholder:text-ink-muted [&::-webkit-search-cancel-button]:hidden"
            {...props}
        />
        {value && (
            <button type="button" aria-label="Clear" onClick={() => { onChange(''); onClear?.(); }} className="inline-flex shrink-0 rounded-full p-0.5 text-ink-muted hover:text-ink-primary">
                <X className="!w-4 !h-4" />
            </button>
        )}
    </label>
));
SearchPill.displayName = 'SearchPill';
export default SearchPill;
